const RESET_PW_INFO = 'index/RESET_PW_INFO' as const;
const SET_RESET_PW_INFO = 'index/SET_RESET_PW_INFO' as const;
export const getResetPwInfo = () => ({
  type: RESET_PW_INFO,
});

export const setResetPwInfo = (state: ResetPwState) => ({
  type: SET_RESET_PW_INFO,
  payload: state,
});

type ResetPwAction = ReturnType<typeof getResetPwInfo> | ReturnType<typeof setResetPwInfo>;

export type ResetPwState = {
  email: string;
  emailAuth: string;
};
const initialState: ResetPwState = {
  email: '',
  emailAuth: ''
};

function resetPw(state: ResetPwState = initialState, action: ResetPwAction): any {
  switch (action.type) {
    case RESET_PW_INFO:
      return { ...state };
    case SET_RESET_PW_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default resetPw;
